import React, { useState } from 'react'
import { Alert, Button, Card, CardActions, CardContent, Grid, IconButton, Snackbar, TextField, Typography } from '@mui/material'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { database } from '../firebaseConfig';
import { addDoc, collection,query,getDocs } from 'firebase/firestore'
import dateFormat, { masks } from "dateformat";

function Doleance() {
  const [reference, setReference] = useState('')
  const [remarque, setRemarque] = useState('')
  const [sentiment, setSentiment] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const envoyer = async () => {
    const reservations = await listReservation()
    setLoading(true)
    setError(false)
    if (reference == '' || remarque == '' || sentiment == '') {
      setLoading(false)
      setError(true)
      // setErrorMessage('Veuilez remplir tous champs possible!')
      setErrorMessage('Fenoy daholo ireo mombamomban\'ny fanamarihana tsy maintsy tokony ho fenoina!')
      return
    }
    const reservationFilter = reservations.filter((res)=>{
      return res.reference==reference
    })
    if(reservationFilter.length==0){
      setLoading(false)
      setError(true)
      // setErrorMessage('Veuilez saisir la réference valide!')
      setErrorMessage('Hamarino tsara ny laharana tany amin\'ny famandrihan-toerana')
      return
    }
    await addDoc(collection(database, 'doleance'), {
      reference: reference,
      remarque: remarque,
      sentiment: sentiment,
      date: dateFormat(new Date(), "yyyy-mm-dd")
    })
    setReference('')
    setRemarque('')
    setSentiment('')
    setLoading(false)

  }
  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setError(false)
  }
  const listReservation = async () => {
    const res = []
    const q = query(collection(database, 'reservation'))
    const reservation_refs = await getDocs(q);
    reservation_refs.forEach(reservation => {
      res.push({
        id: reservation.id,
        ...reservation.data()
      })
    })
    return res
  }
  return (
    <div >
      <Grid container spacing={2}>
        <Grid item md={6} sm={6} xs={12}>
          <Card sx={{ maxWidth: {md:500,sm:400,xs:400}, height: {md:350,sm:400,xs:400},margin:1 }} >
            <CardContent>
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                <b>Miarahaba Tompoko,</b>
                <br />
                <br />
                Mihaino anao ny Ministeran’ny fahasalamam-bahoaka ary eo anilanao mandrakariva

                Zava-dehibe ny fahafampon’ny isambatan’olona na ny marary na ny mpikarakara ny marary satria « Izay marary andrianina »
                Koa raha misy tranga tianao hoampitaina, na koa misy Sosokevitra ahafahana manatsara ny kalitaon’ny tolotra ara-pahasalamana, dia manasa anao izahay mba hizara izany aminay
                Irinay sy ankasitrahanay tokoa ianao izay manoratra raha mametraka ny email ahafahantsika mifandray satria ny serasera no lalana tokana izay ahafahanay manatsara hatrany izay kalitao izay

                Ny fomba izay ahafahanao mifandray dia misy ny pejy izay fenoinao, koa asaina ianao hilaza amin’ny antsipirihany ny tranga tianao zaraina aminay mba itondrana vahaolana mahomby sy maharitra

                Ny Ministeran’ny fahasalamam-bahoaka eo anilanao hatrany.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Card sx={{ maxWidth: {md:500,sm:400,xs:400}, height: {md:350,sm:400,xs:400},margin:1 }}  >
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} >
                  <TextField margin="normal"
                    required
                    fullWidth
                    id="reference"
                    // label="Réference"
                    label="Laharana tamin'ny famandrihan-toerana"
                    value={reference}
                    onChange={(e) => {
                      setReference(e.target.value)
                    }}
                    autoFocus />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="remarque"
                    // label="Rémarque"
                    label="Fanamarihana"
                    multiline
                    fullWidth
                    rows={2}
                    value={remarque}
                    onChange={(e) => {
                      setRemarque(e.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton disabled={sentiment!=''&& sentiment!='Heureux'} sx={{ bgcolor: 'rgb(103,181,26)', marginRight: 1 }} onClick={() => {
                    setSentiment('')
                    if(sentiment!='Heureux'){
                      setSentiment('Heureux')
                    }
                  }}>
                    <SentimentSatisfiedAltIcon />
                  </IconButton>
                  <IconButton disabled={sentiment!=''&& sentiment!='Très Heureux'} sx={{ bgcolor: 'red', marginRight: 1 }} onClick={() => {
                    setSentiment('')
                    if(sentiment!='Très Heureux'){
                      setSentiment('Très Heureux')
                    }
                  }}>
                    <FavoriteBorderIcon />
                  </IconButton>
                  <IconButton disabled={sentiment!=''&& sentiment!='Triste'} sx={{ bgcolor: 'yellow', marginRight: 1 }} onClick={() => {
                    setSentiment('')
                    if(sentiment!='Triste'){
                      setSentiment('Triste')
                    }
                  }}>
                    <SentimentVeryDissatisfiedIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              {/* <Button style={{ width: '100%', marginBottom: 5 }} size='small' variant='contained' color='success' onClick={envoyer}>Envoyer</Button> */}
              <Button style={{ width: '100%', marginBottom: 5 }} size='small' variant='contained' color='success' onClick={envoyer}>Alefa</Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert severity="error"
          variant="filled"
          sx={{ width: '100%' }}
          onClose={handleCloseAlert}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Doleance